module.exports = __webpack_public_path__ + "plus/img/498c7d3df9a340682e7aa22d98b1ab3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/deps/public/footer3.png
// module id = pda6
// module chunks = 6